export const encodeBase64Json = (data: unknown) => {
    return btoa(JSON.stringify(data));
};

export const decodeBase64Json = (data: string) => {
    return JSON.parse(atob(data)) as unknown;
};
